import React, { useMemo } from "react";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Alert from "@mui/material/Alert";
import AlertTitle from "@mui/material/AlertTitle";

import InfoIcon from "@mui/icons-material/Info";
import DemoState from "./DemoState";
import { useAuth } from "components/SessionAuth";

export default function DemoBanner() {

    let demoState =  DemoState.status()
    const {logout} = useAuth()

    console.log('demo state', demoState)
    if (!demoState.status) {
        return null
    }

    const handleExitDemoMode = async () => {
        DemoState.turnOffDemoMode()
        await logout()
        window.location.href = '/login'
    }


    return (
        <Box sx={{ width: "300px", mb: 2, position: 'fixed', left: 0, bottom: 0,  ml: 1, zIndex: 9999 }}>
            <Alert severity="success" icon={<InfoIcon />} action={
                <Button color="inherit" size="small" onClick={handleExitDemoMode} data-testid="exit-demo-btn">
                    Exit Demo
                </Button>
            }>
                <AlertTitle>Demo Mode</AlertTitle>
                You are currently using a demo account. Some features may be limited.
            </Alert>
        </Box>
    );
}